import { useLocation } from "wouter";
import { Flame, XCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { apiRequest } from "@/lib/queryClient";
import { useState } from "react";

export default function SignupCancelPage() {
  const [, setLocation] = useLocation();
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetryCheckout = async () => {
    setIsRetrying(true);
    try {
      const response = await apiRequest('POST', '/api/signup/checkout');
      const { url } = await response.json();
      window.location.href = url;
    } catch (error) {
      console.error('Failed to restart checkout:', error);
      setIsRetrying(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="p-3 bg-primary/20 rounded-xl">
            <Flame className="w-8 h-8 text-primary animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            myFit<span className="text-primary">Beats</span>
          </h1>
        </div>

        <div className="bg-card border border-border/50 rounded-xl p-8">
          <XCircle className="w-12 h-12 mx-auto mb-4 text-amber-500" />
          <h2 className="text-xl font-semibold mb-2">Subscription Setup Cancelled</h2>
          <p className="text-muted-foreground mb-6">
            No worries! You can complete your subscription setup anytime to access all features.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={handleRetryCheckout}
              className="w-full"
              disabled={isRetrying}
              data-testid="button-retry-checkout"
            >
              {isRetrying ? "Loading..." : "Complete Subscription Setup"}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            
            <Button 
              variant="ghost"
              onClick={() => setLocation('/auth')}
              className="w-full text-muted-foreground"
              data-testid="button-return-signin"
            >
              Return to Sign In
            </Button>
          </div>

          <p className="text-xs text-muted-foreground mt-4">
            14-day free trial, then $8.99/month. Cancel anytime.
          </p>
        </div>
      </div>
    </div>
  );
}
